export default __webpack_public_path__ + "static/media/gallery-wps-6.21d20a1c.jpg";